import React, { memo, useEffect, useMemo, useState } from 'react';
import Modal from '../../../components/Modal/modal';
import { useLang } from '../../../util/lang';
import { smilDesignQuestionsConfigFirstFit, smileDesignQuestionsAlignConfig } from '../SmileDesignQuestions';
import { safeGet } from '../../../axios-default';
import LoadingSpinner from '../../../components/Loader/LoadingSpinner';
import { CaseLogInfo } from '../../../components/Modal/CaseLogModal';
import ImpressionViewer from '../../../components/PatientInfo/ImpressionViewer';
import { Grid, TextField } from '@material-ui/core';
import Moment from 'moment/moment';
import { restorationFormQuestion } from './RestorationFormQuestion';
import { isEmpty } from '../../../util/function';
import PrescriptionNoteStep from '../../RestorativePhaseCaseIntake/PrescriptionNoteStep';

const partialTranslation = (ans, get) => {
    if (ans !== undefined && ans !== null && ans !== '' && (ans.startsWith('@') || ans.startsWith('option'))) {
        return get(`@PatientInfo.smileDesign.prescriptionNotes.${ans}`);
    }
    return ans;
};

const getRestorationFormData = async (caseId, restorationFormId) => {
    const results = await safeGet(`/case/restorationForm/${caseId}/${restorationFormId}`);
    return results;
};

const ViewRestorationFormModal = ({ open, handleClose, caseId, restorationFormId }) => {
    const get = useLang();
    const restorationFormConfig = restorationFormQuestion();
    const [data, setData] = useState(null);
    const [isLoading, setIsloading] = useState(true);
    const restorationForm = data?.restorationForm || {};
    const isFirstFitForm = Boolean(restorationForm.plannedRestorationSolution);
    const firstFitQ1Options = useMemo(
        () => smilDesignQuestionsConfigFirstFit(undefined, restorationForm.isMarieGroup)[1].option,
        [restorationForm.isMarieGroup]
    );

    useEffect(() => {
        const fetchData = async () => {
            setIsloading(true);
            if (open && caseId !== undefined && restorationFormId !== undefined) {
                const data = await getRestorationFormData(caseId, restorationFormId);
                setData(data.result);
                setIsloading(false);
            }
        };
        fetchData();
    }, [caseId, restorationFormId, open]);

    return (
        <Modal
            className="prescriptionNotes"
            modal="ViewRestorationFormModal"
            title={'Restoration Tool'}
            handleClose={handleClose}
            open={open}
            submitButton={false}
            modalError={false}
        >
            {isLoading ? (
                <LoadingSpinner />
            ) : isFirstFitForm ? (
                <PrescriptionNoteStep readOnly data={restorationForm} q1Options={firstFitQ1Options} />
            ) : (
                <>
                    <div style={{ display: 'block', width: '100%' }}>
                        <p style={{ display: 'inline', marginRight: '15px' }}>
                            <strong>{get('@PatientInfo.modals.uploadedAt')}</strong> :
                            {Moment(data.restorationForm.created_date).format('YYYY-MM-DD HH:mm')}
                        </p>
                        <hr />
                    </div>
                    <div style={{ marginTop: 16 }}>
                        <div>{get(restorationFormConfig[1].question)}</div>
                        {data?.restorationForm.toolsToOrder.map((v, i) => {
                            return (
                                <li key={i} style={{ fontWeight: 'bold', paddingLeft: 16 }}>
                                    {partialTranslation(v, get)}
                                </li>
                            );
                        })}
                    </div>

                    <div style={{ marginTop: 8 }}>
                        <div>{get(restorationFormConfig[2].question)}</div>
                        <div style={{ fontWeight: 'bold', paddingLeft: 16 }}>
                            <TextField
                                value={data?.restorationForm.restorationRemark}
                                style={{ width: '100%', marginTop: 4 }}
                                multiline={true}
                                minRows={4}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    </div>
                    {!isEmpty(data.caseImpression) && (
                        <div style={{ marginTop: 24 }}>
                            <Grid item xs={12} sm={12} md={12} style={{ padding: 8, textAlign: 'left' }}>
                                <ImpressionViewer caseImpression={data.caseImpression} />
                            </Grid>
                        </div>
                    )}
                </>
            )}
        </Modal>
    );
};

export default memo(ViewRestorationFormModal);
